module.exports = __webpack_public_path__ + "img/cog.ee00dfc7.svg";